import "./assets/styles/global.scss";
import Routes from "./Routes";
import AuthProvider from "./providers/AuthProvider";
import LocationProvider from "./providers/LocationProvider";
import NotificationProvider from "./providers/NotificationProvider";
import InfoModalProvider from "./providers/InfoModalProvider";
import EndedSelectionProvider from "./providers/EndedSelectionProvider";
import EndedActionBar from "./components/EndedActionBar";
import { useEffect } from "react";
import { getThemeSettings } from "./services/api";
import { applyThemeVariables } from "./utils/theme";
// Inicializar o Google Analytics 4

import ReactGA from 'react-ga4';

ReactGA.initialize('G-CK9RG9DXFY');

export default function App() {
  /*useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/", title: "cacadoresdeofertas" });
  }, []);*/
  useEffect(() => {
    const loadTheme = async () => {
      try {
        const response = await getThemeSettings();
        if (response?.success && response?.data) {
          applyThemeVariables(response.data);
        }
      } catch (error) {
        // Silencia erros de tema para não bloquear o app
      }
    };

    loadTheme();
  }, []);
  return (
    <NotificationProvider>
      <InfoModalProvider>
        <AuthProvider>
          <EndedSelectionProvider>

            <Routes />
            <EndedActionBar />

          </EndedSelectionProvider>
        </AuthProvider>
      </InfoModalProvider>
    </NotificationProvider>
  );
}
